import { pathRedirect } from '@/utils/auth'

import Dashboard from '@/containers/MeterReading/Dashboard'
import Schedule from '@/containers/MeterReading/Schedule'
import Incident from '@/containers/MeterReading/Incident'
import Account from '@/containers/MeterReading/Account'
import waterMeter from '@/containers/MeterReading/WaterMeter'
import Book from '@/containers/MeterReading/Book'
import Patrol from '@/containers/MeterReading/Patrol'
import Record from '@/containers/MeterReading/Record'
import DataBackhaul from '@/containers/MeterReading/DataBackhaul'
import Task from '@/containers/MeterReading/Task'
import Track from '@/containers/MeterReading/Track'
import test from '@/containers/MeterReading/Dashboard/test'

export default {
  path: 'meterReading',
  redirect: pathRedirect,
  children: [
    { path: 'dashboard', component: Dashboard },
    { path: 'schedule', component: Schedule },
    { path: 'incident', component: Incident },
    { path: 'account', component: Account },
    { path: 'waterMeter', component: waterMeter },
    { path: 'book', component: Book },
    { path: 'patrol', component: Patrol },
    { path: 'record', component: Record },
    { path: 'dataBackhaul', component: DataBackhaul },
    { path: 'track/:id', component: Track },
    { path: 'test', component: test },
    { path: 'task', component: Task }
  ],
  component: {
    template: '<router-view></router-view>'
  }
}



// WEBPACK FOOTER //
// ./src/router/meterReading.js